import Vue from 'vue'
import Vuex from 'vuex'

import createPersistedState from "vuex-persistedstate"
// 应用vuex插件
Vue.use(Vuex)

// 创建并暴露store
export default new Vuex.Store({
    // 数据,相当于data
    state: {
        shoppingData: [{ name: '李建成' }]
    },
    //准备getters——用于将state中的数据进行加工
    getters: {

    },
    //准备mutations——用于操作数据（state）
    mutations: {
        getDataArr (state, data) {
            state.satellite = data
          },
    },
    //准备actions——用于响应组件中的动作
    actions: {

    },
    modules: {},
    plugins: [createPersistedState({
        storage: window.sessionStorage
    })]
})